export default "__VITE_ASSET__BR2aJP81__"